/* eslint-disable @angular-eslint/prefer-inject */
import { PickDataService } from '../infrastructure/picks/pick.data.service';
import {
    PickCreate,
    PickDto,
    PickRead,
    PickSearchParams,
} from '../entities/pick.dto';
import { PickStore } from '../infrastructure/picks/pick.store';
import { inject, Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { PickMapper } from '../infrastructure/picks/pick.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { SafeAny } from '@pf/shared-common';
import { WarehouseFacade } from './warehouse.facade';
import { ResourceAuth } from '@control-tower/platform-wms';

@Injectable()
export class PickFacade extends AbstractManageEntityFacade<
    PickDto,
    PickRead,
    PickCreate,
    PickSearchParams
> {
    private readonly warehouseFacade = inject(WarehouseFacade);
    nameField: keyof PickDto = 'name';

    constructor(
        dataService: PickDataService,
        store: PickStore,
        mapper: PickMapper
    ) {
        super(dataService, null, store, mapper);
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField as SafeAny
    );

    /** Resource auth set to same as parent (pick list / warehouse) for now. */
    override applyResourceAuth(body: PickCreate): void {
        const locationId = this.warehouseFacade.active?.location?.id;
        body.resourceAuth = {
            locations: locationId ? [locationId] : [],
        } as ResourceAuth;
    }

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof PickDto, string>> {
        return { name: searchText };
    }

    completePick$(
        inventoryBundleId: string,
        pickToContainerId: string,
        pickedQuantity: number,
        pickLocationId: string
    ) {
        return (this.dataService as PickDataService).pickInventory$(
            inventoryBundleId,
            pickToContainerId,
            pickedQuantity,
            pickLocationId
        );
    }

    splitPick$(
        warehouseId: string,
        pickId: string,
        pickLocationId: string,
        newQuantity: number
    ) {
        return (this.dataService as PickDataService).splitPickLocation$(
            warehouseId,
            pickId,
            pickLocationId,
            newQuantity
        );
    }

    cancelPick$(pickId: string, pickLocationIds: string[] = []) {
        return (this.dataService as PickDataService).cancelPick$(
            pickId,
            pickLocationIds
        );
    }
}
